import './index.scss';
import { useParams } from 'react-router-dom';
import Header from '../../../../../../../components/Header/Header';
import useSafeLock from '../../../../../../../hooks/useSafeLock';
import NoData from '../../../../../../../components/NoData/NoData';
import { useEffect, useRef, useState } from 'react';
import usePiggybank from '../../../../../../../hooks/usePiggybank';
import { convertToNaira, useOutsideClick } from '../../../../../../../helpers/utils';
import dayjs from 'dayjs';
import { LuMoreVertical } from 'react-icons/lu';

import failureIcon from '../../../../../../../assets/icons/failureIcon.svg';
import successIcon from '../../../../../../../assets/icons/succesIcon.svg';
import updateMemo from '../../../../../../../assets/icons/updateMemo.svg';
import Info from '../../../../../../../assets/icons/Info.svg';
import trashIcon from '../../../../../../../assets/icons/trashr.svg';
import reverseIcon from '../../../../../../../assets/icons/reverseTransactions.svg';
import Dropdown from '../../../../../../../components/Dropdown/Dropdown';
import TransactionDetailsAlt from '../../../../../../../components/NewSideSheet/TransactionDetailsAlt/TransactionDetailsAlt';
import ModalDeleteTransaction from '../../../../../../../components/Modals/ModalDeleteTransaction';
import ModalUpdateTransactionMemo from '../../../../../../../components/Modals/ModalUpdateTransactionMemo';
import Pagination from '../../../../../../../components/Pagination/Pagination';
import ModalTransactionSearch from '../../../../../../../components/Modals/ModalTransactionSearch';
import useTransaction from '../../../../../../../hooks/useTransaction';
import { Loader } from '@piggytechng/component-library';

const index = () => {
  const params = useParams();
  const activeTab = params.activeTab as string;
  const { pendingSafelocksQ, completedSafelocksQ } = useSafeLock();
  const {
    piggybankTransactionsQ,
    isLoadingPiggybankTransactionsQ,
    refetchPiggybankTransactionsQ,
    transactionsParams,
    setTransactionsParams,
    searchPiggybankTransactions,
    clearPiggybankSearch,
    searchedPiggybankTransactions,
    isSearchingPiggybank,
  } = usePiggybank();
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [appliedSearch, setAppliedSearch] = useState<{ filter: string; query: string } | null>(null);

  const transactionsToShow = searchedPiggybankTransactions ?? piggybankTransactionsQ?.results;

  const handleApplySearch = (filter: string, query: string) => {
    setAppliedSearch({ filter, query });
    searchPiggybankTransactions(query, filter, 1, transactionsParams.limit);
    setShowSearchModal(false);
  };

  const handleResetSearch = () => {
    setAppliedSearch(null);
    clearPiggybankSearch();
  };
  const { deleteTransaction, updateTransactionMemo, isLoading: isTransactionLoading } = useTransaction();
  const [show, setShow] = useState(false);
  const [trDetails, setTrDetails] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedTransactionRef, setSelectedTransactionRef] = useState<string>('');
  const [showUpdateMemoModal, setShowUpdateMemoModal] = useState(false);
  const [selectedTransactionForMemo, setSelectedTransactionForMemo] = useState<{ reference: string; memo: string }>({
    reference: '',
    memo: '',
  });
  const [showDropdown, setShowDropdown] = useState({
    index: -1,
    show: false,
  });

  const [, setActiveTabTransactions] = useState([]);

  const dropdownRef = useRef(null);
  const actionRef = useRef(null);
  useOutsideClick(dropdownRef, setShowDropdown, actionRef);

  useEffect(() => {
    if (activeTab === 'active') {
      setActiveTabTransactions(pendingSafelocksQ?.list ?? []);
    } else {
      setActiveTabTransactions(completedSafelocksQ?.list ?? []);
    }
  }, [activeTab, pendingSafelocksQ, completedSafelocksQ]);

  const handleShowTransactionsDetails = (data: any) => {
    const formattedData = {
      transactionId: data.asw_id,
      owner: data.asw_own,
      plan: data.asw_plan,
      amount: convertToNaira(data.asw_value * 100),
      memo: data.asw_memo,
      unique: data.asw_unique,
      type: data.asw_type,
      reference: data.asw_ref,
      balance: convertToNaira(data.asw_balance * 100),
      date: dayjs.unix(data.asw_date).format('D MMM YYYY | h:mm A'),
    };

    setShow(true);
    setTrDetails(formattedData);
  };

  const handleDeleteTransaction = (reference: string) => {
    setSelectedTransactionRef(reference);
    setShowDeleteModal(true);
  };

  const handleDeleteSuccess = () => {
    refetchPiggybankTransactionsQ();
  };

  const handleUpdateMemo = (reference: string, currentMemo: string) => {
    setSelectedTransactionForMemo({ reference, memo: currentMemo });
    setShowUpdateMemoModal(true);
  };

  const handleUpdateMemoSuccess = () => {
    refetchPiggybankTransactionsQ();
  };

  const handleShowDropdown = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, i: number) => {
    e.stopPropagation();
    if (i === showDropdown.index) {
      setShowDropdown({ ...showDropdown, show: false, index: -1 });
    } else {
      setShowDropdown({ ...showDropdown, show: true, index: i });
    }
  };

  const getDropdownArray = (reference: string, currentMemo: string) => [
    {
      icon: updateMemo,
      text: 'Update memo',
      fn: () => handleUpdateMemo(reference, currentMemo),
    },
    {
      icon: Info,
      text: 'See more info',
      fn: () => console.log('run'),
    },
    {
      icon: trashIcon,
      text: 'Delete transaction',
      fn: () => handleDeleteTransaction(reference),
    },
    {
      icon: reverseIcon,
      text: 'Reverse transaction',
      fn: () => console.log('run'),
    },
  ];

  return (
    <div className="view-all-piggybank">
      <Header name={'Piggybank Transactions'} backButton />

      <div className="content">
        <div className="customers-filter">
          <div className="input-field">
            <input
              type="text"
              readOnly
              placeholder="Search transactions"
              value={appliedSearch ? `${appliedSearch.filter}: ${appliedSearch.query}` : ''}
              onClick={() => setShowSearchModal(true)}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <div className="query-filter" onClick={() => setShowSearchModal(true)}>
            <div>
              <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                  stroke="#1E293B"
                  strokeWidth="1.5"
                  strokeLinecap="square"
                />
              </svg>
            </div>
            <div>Search</div>
          </div>
          <div className="query-filter" onClick={handleResetSearch}>
            <div></div>
            <div>Reset</div>
          </div>
        </div>

        {isLoadingPiggybankTransactionsQ || isSearchingPiggybank ? (
          <div className="page-loader">
            <Loader color="#0F60D6" />
          </div>
        ) : transactionsToShow?.length ? (
          <div className="table-container housemoney piggybank">
            <table className="table">
              <thead className="table_head">
                <tr>
                  {/* <th className="icon">{''}</th> */}
                  <small></small>
                  <th className="date">Date</th>
                  <th className="amount">{`Amount (₦)`}</th>
                  <th className="balance">{`Balance (₦)`}</th>
                  <th className="memo">Memo</th>
                  <th className="transactionID">Transaction ID</th>
                </tr>
              </thead>

              <tbody className="table-body">
                {transactionsToShow?.map((txn: any, i: number) => {
                  const isCredit = txn.asw_value > 0;

                  return (
                    <tr key={txn.asw_id} className="table-row" onClick={() => handleShowTransactionsDetails(txn)}>
                      {/* <td className="icon">
                      </td> */}
                      <img src={isCredit ? successIcon : failureIcon} alt={isCredit ? 'credit' : 'debit'} />
                      <td>{dayjs.unix(txn.asw_date).format('D MMM YYYY | h:mm A')}</td>
                      <td>
                        {isCredit ? '+' + convertToNaira(txn.asw_value * 100) : convertToNaira(txn.asw_value * 100)}
                      </td>
                      <td className="balance">{convertToNaira(txn.asw_balance * 100)}</td>
                      <td className="memo">{txn.asw_memo}</td>
                      <td className="tr-id">{txn.asw_ref}</td>

                      {/* <td className="chevron-cell">
                        <img className="chevron-table" src={chevronTable} />
                      </td> */}

                      <div className="dropdown-container" ref={actionRef}>
                        <button onClick={(e) => handleShowDropdown(e, i)} className="pointer">
                          <LuMoreVertical color="#CBD5E1" size={25} />
                        </button>

                        {showDropdown.index === i && showDropdown.show && (
                          <div className="table-dropdown" ref={dropdownRef}>
                            <Dropdown data={getDropdownArray(txn.asw_ref, txn.asw_memo || '')} index={i} />
                          </div>
                        )}
                      </div>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <NoData message={'No transaction at the moment.'} />
        )}

        {!searchedPiggybankTransactions && (
          <Pagination
            currentPage={transactionsParams.page}
            hasNextPage={(piggybankTransactionsQ?.results?.length ?? 0) >= transactionsParams.limit}
            hasPrevPage={transactionsParams.page > 1}
            onNextPage={() => setTransactionsParams((prev) => ({ ...prev, page: prev.page + 1 }))}
            onPrevPage={() => setTransactionsParams((prev) => ({ ...prev, page: Math.max(prev.page - 1, 1) }))}
            limit={transactionsParams.limit}
            onLimitChange={(newLimit) => setTransactionsParams({ page: 1, limit: newLimit })}
          />
        )}
      </div>

      <ModalTransactionSearch
        modalIsOpen={showSearchModal}
        setIsOpen={setShowSearchModal}
        onApply={handleApplySearch}
        onClear={handleResetSearch}
        isLoading={isSearchingPiggybank}
        initialFilter={appliedSearch?.filter}
        initialQuery={appliedSearch?.query}
      />

      <TransactionDetailsAlt
        show={show}
        id={''}
        data={trDetails}
        onClose={() => {
          setShow(false);
        }}
      />
      {selectedTransactionRef && (
        <ModalDeleteTransaction
          modalIsOpen={showDeleteModal}
          setIsOpen={setShowDeleteModal}
          reference={selectedTransactionRef}
          wallet="piggybank"
          onDelete={deleteTransaction}
          onSuccess={handleDeleteSuccess}
          isLoading={isTransactionLoading}
        />
      )}
      {selectedTransactionForMemo.reference && (
        <ModalUpdateTransactionMemo
          modalIsOpen={showUpdateMemoModal}
          setIsOpen={setShowUpdateMemoModal}
          reference={selectedTransactionForMemo.reference}
          wallet="piggybank"
          currentMemo={selectedTransactionForMemo.memo}
          onUpdate={updateTransactionMemo}
          onSuccess={handleUpdateMemoSuccess}
          isLoading={isTransactionLoading}
        />
      )}
    </div>
  );
};

export default index;
